'use strict';

var angular = require('angular');
var dependencies = ['AVRO.Common.UserSecure', 'AVRO.Common.Moment', 'AVRO.Common.Configuration'];
module.exports = angular.module('AVRO.Common.UserPreferences', dependencies).run(require('./config/UserPreferencesConfig')).service('UserPreferencesService', require('./services/UserPreferencesService'));